import {handlerButton} from "@frontend/group/modules/copy-and-resize";
import {LAYOUT_SAVE_EVENTS, layoutSaveEventBroker} from "@frontend/group/modules/layout-save/event-broker";

export const POST_ACTION_RESIZE_KEY= 'resize';
export const POST_ACTION_RESIZE_DATA_KEY = `post-action:resize`;

export const resize = () => {
  const needsToBeSavedAfterLoaded = $("#template-group-preview").attr("data-needs-to-be-saved-after-loaded") == '1';

  const actionDataJSON = localStorage.getItem(POST_ACTION_RESIZE_DATA_KEY);

  if (!actionDataJSON) {
    console.error('POST-ACTION:RESIZE - No data found');
    return;
  }

  const actionData = JSON.parse(actionDataJSON);

  if (!actionData.sizes) {
    console.error('POST-ACTION:RESIZE - No sizes found');
  }

  localStorage.removeItem(POST_ACTION_RESIZE_DATA_KEY);

  const runResize = () => {
    const instanceId = window.previews[0].id;
    const $btn = $(`.resize-template[data-id=${instanceId}][data-url]`);

    handlerButton({
      instanceId,
      withCopingTemplate: true,
      preselectedSizes: actionData.sizes,
      instantRun: true,
      context: $btn
    });
  };

  if (needsToBeSavedAfterLoaded) {
    layoutSaveEventBroker.on(LAYOUT_SAVE_EVENTS.SAVED, runResize, true);
  } else {
    runResize();
  }
};
